var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('SensesMenu',{attrs:{"id":"land-transitions"}}),_c('article',[_c('Intro')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }